import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useMemo, createContext, useContext } from "react";
var PaneContext = createContext(null);
export var PaneProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), showLeft = _b[0], setShowLeft = _b[1];
    var _c = useState(false), showRight = _c[0], setShowRight = _c[1];
    var _d = useState("grid"), viewMode = _d[0], setViewMode = _d[1];
    var _e = useState("slider"), selectionSource = _e[0], setSelectionSource = _e[1];
    var _f = useState(false), buy = _f[0], setBuy = _f[1];
    var _g = useState(false), offer = _g[0], setOffer = _g[1];
    var _h = useState(false), collectionOffer = _h[0], setCollectionOffer = _h[1];
    var value = useMemo(function () { return ({
        showLeft: showLeft,
        showRight: showRight,
        toggleLeft: function () { return setShowLeft(function (value) { return !value; }); },
        toggleRight: function () { return setShowRight(function (value) { return !value; }); },
        viewMode: viewMode,
        selectionSource: selectionSource,
        setViewMode: setViewMode,
        setAddSlider: function () { return setSelectionSource("slider"); },
        setAddCard: function () { return setSelectionSource("card"); },
        buyModal: buy,
        openBuyModal: function () { return setBuy(true); },
        closeBuyModal: function () { return setBuy(false); },
        offerModal: offer,
        openOfferModal: function () { return setOffer(true); },
        closeOfferModal: function () { return setOffer(false); },
        collectionOfferModal: collectionOffer,
        openCollectionOfferModal: function () { return setCollectionOffer(true); },
        closeCollectionOfferModal: function () { return setCollectionOffer(false); },
    }); }, [showLeft, showRight, viewMode, selectionSource, buy, offer, collectionOffer]);
    return _jsx(PaneContext.Provider, { value: value, children: children });
};
export var usePaneLayout = function () {
    var ctx = useContext(PaneContext);
    if (!ctx) {
        throw new Error("usePaneLayout must be used inside PaneLayoutProvider");
    }
    return ctx;
};
export var useOptionalPaneLayout = function () { return useContext(PaneContext); };
